import $foreign from "./foreign.cjs";
var append = $foreign.append;
var appendText = $foreign.appendText;
var attr = $foreign.attr;
var before = $foreign.before;
var body = $foreign.body;
var clear = $foreign.clear;
var clone = $foreign.clone;
var cloneWithDataAndEvents = $foreign.cloneWithDataAndEvents;
var closest = $foreign.closest;
var create = $foreign.create;
var css = $foreign.css;
var deafen = $foreign.deafen;
var delegate = $foreign.delegate;
var find = $foreign.find;
var getAttrImpl = $foreign.getAttrImpl;
var getCurrentTarget = $foreign.getCurrentTarget;
var getHtml = $foreign.getHtml;
var getMetaKey = $foreign.getMetaKey;
var getPageX = $foreign.getPageX;
var getPageY = $foreign.getPageY;
var getProp = $foreign.getProp;
var getTarget = $foreign.getTarget;
var getText = $foreign.getText;
var getValue = $foreign.getValue;
var getWhich = $foreign.getWhich;
var hasClass = $foreign.hasClass;
var off = $foreign.off;
var on = $foreign.on;
var parent = $foreign.parent;
var preventDefault = $foreign.preventDefault;
var ready = $foreign.ready;
var remove = $foreign.remove;
var select = $foreign.select;
var setAttr = $foreign.setAttr;
var setClass = $foreign.setClass;
var setHtml = $foreign.setHtml;
var setProp = $foreign.setProp;
var setText = $foreign.setText;
var setValue = $foreign.setValue;
var setVisible = $foreign.setVisible;
var stopImmediatePropagation = $foreign.stopImmediatePropagation;
var stopPropagation = $foreign.stopPropagation;
var toArray = $foreign.toArray;
var toggle = $foreign.toggle;
var toggleClass = $foreign.toggleClass;
var unsafeAppendHtml = $foreign.unsafeAppendHtml;
export { append, appendText, attr, before, body, clear, clone, cloneWithDataAndEvents, closest, create, css, deafen, delegate, find, getAttrImpl, getCurrentTarget, getHtml, getMetaKey, getPageX, getPageY, getProp, getTarget, getText, getValue, getWhich, hasClass, off, on, parent, preventDefault, ready, remove, select, setAttr, setClass, setHtml, setProp, setText, setValue, setVisible, stopImmediatePropagation, stopPropagation, toArray, toggle, toggleClass, unsafeAppendHtml };
